// extracted by mini-css-extract-plugin
export default {"field":"style_field__Wm+pB","leftMarging":"style_leftMarging__6rWVe"};